import { orchestrator } from 'satcheljs';
import { onSurfaceClick } from '../actions/surfaceOnClickActions';
import { executeCommand } from 'owa-calendar-command-executor';
import { createQuickComposePreviewItem } from 'owa-quick-compose-controller';
import { returnTopExecutingActionDatapoint } from 'owa-analytics';
import { getSurfaceStore } from 'owa-calendar-surface-surface-store';

/**
 * Opens the quick-compose for creating a new event
 *
 */
orchestrator(onSurfaceClick, actionMessage => {
    const datapoint = returnTopExecutingActionDatapoint();
    datapoint.addCustomData({ currentDateRangeType: getSurfaceStore().dateRangeType });

    executeCommand(
        () =>
            createQuickComposePreviewItem(
                getSurfaceStore(),
                actionMessage.start,
                actionMessage.end,
                actionMessage.isAllDay,
                actionMessage.isClickAndDragEvent,
                actionMessage.selectedCalendarFolderId
            ),
        0
    );
});
